<!--
 * @Author: LiuMouLiang
 * 提示对话框
import tipsDialog from '_c3/tips/tips-dialog.vue';
<tips-dialog
    v-model="tipsContentShow"
    :content="tipsContent"
    @ok="tipsContent_ok"
    isFooter
    width="335px">
</tips-dialog>
-->
<template>
    <apply-dialog
        v-model="isShow"
        :title="title"
        :width="width"
        :top="top"
        :isFooter="false"
        :append-to-body="appendToBody"
        :customClass="customClassName"
        :loading="loading"
        @ok="dialog_ok">
        <template v-if="content" >
            {{content}}
        </template>
        <template v-else >
            <slot />
        </template>
        <template slot="footer" v-if="isFooter">
            <form-button class="operation-button tips-button" @click="dialog_ok">{{footerName}}</form-button>
        </template>
        <template slot="footer" v-else>
            <slot name="footer" />
        </template>
    </apply-dialog>
</template>

<script>
/* eslint-disable */
import { getObjVal } from 'tools';
export default {
    name: 'tipsDialog',
    props: {
        value: null,
        title: String,
        content: String,
        width: {
            type: String,
            default: '360px'
        },
        top: {
            type: String,
            default: '15vh'
        },
        appendToBody: {
            type: Boolean,
            default: false
        },
        customClass: String,
        loading: {
            type: Boolean,
            default: false
        },
        isFooter: {
            type: Boolean,
            default: false
        },
        footerName: {
            type: String,
            default: '我知道了'
        },
        maxHeight: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
        dialog_ok(){
            if(this.loading) return false;
            this.$emit('ok')
        }
    },
    created(){},
    components: {},
    computed: {
        isShow: {
            get({value}){
                return value
            },
            set(newVal){
                this.$emit("input", newVal);
            }
        },
        customClassName({ customClass, title }){
            let res = 'tipsDialog';
            if(this.maxHeight) {
                res += ' max-height'
            }
            res = customClass ? res + ' ' + customClass :  res;
            if(title) {
                res += ' tipsDialog-hasTitle'
            }
            return res;
        }
    },
    mixins: [],
}
</script>
<style lang="less">
@import "~_css/theme.less";
.applyDialog.el-dialog.tipsDialog{
    border-radius: 4px;
    .el-dialog__header{
        // padding: 16px 20px 14px;
    }
    &-hasTitle{
        .el-dialog__header{
            padding: 16px 20px 14px;
            border-bottom: 1px solid #F1F3F8;
        }
    }
    .el-dialog__footer{
        border-top: 1px solid #F1F3F8;
        text-align: center;
        padding: 14px 20px 15px;
    }
    .applyDialog-title{
        font-weight: bold;
        font-size: 16px;
        color: rgba(0,0,0,0.85);
    }
    .tips-button{
        width: 214px;
        background-color: @blue;
        border-color: @blue;
        border-radius: 2px;
        box-shadow: 0px 6px 14px 0px rgba(0,0,0,0.1);
    }
    .el-dialog__body{
        padding: 15px 20px 15px;
        overflow-y: auto;
        color: #333;
    }
    .model-wraper{
        line-height: 1.5;
    }
    &.max-height{
        .el-dialog__body{
            max-height: 60vh;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components_v3/tips/tips-dialog.vue